export const prerender = true;
export const ssr = true;
export const trailingSlash = 'always';
